import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Item.st.css.js';
const Item = ({ disabled, draggable, children, className }) => (React.createElement("div", { className: st(classes.root, { disabled, draggable }, className) }, children));
Item.displayName = 'TimeTable.Item';
Item.propTypes = {
    disabled: PropTypes.bool.isRequired,
    draggable: PropTypes.bool.isRequired,
};
export default Item;
//# sourceMappingURL=Item.js.map